enum StockSymbolActionTypeKeys {
  STOCK_SYMBOL_SERVICE_LIST_REQUESTED = 'STOCK_SYMBOL_SERVICE_LIST_REQUESTED',
  STOCK_SYMBOL_LIST_REQUEST_SUCCEEDED = 'STOCK_SYMBOL_LIST_REQUEST_SUCCEEDED',
  STOCK_SYMBOL_SERVICE_LIST_REQUEST_FAILED = 'STOCK_SYMBOL_SERVICE_LIST_REQUEST_FAILED',
  STOCK_SYMBOL_SERVICE_LIST_RESET = 'STOCK_SYMBOL_SERVICE_LIST_RESET',
}

export default StockSymbolActionTypeKeys;
